import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormInput from '../../../../../library/form/components/FormInput';
import FormSH from '../../../../../library/form/components/FormSH';
import SarasTrans from '../../../../../library/notifications/SarasTrans';

const DesignOPSSearchBatchAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    const onActionSuccess = () => {
        if(reloadSearch)reloadSearch(1);
    }

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch(1);
    }

    return (
        <div className='uiFlexBox'>
            <FormButton formObject={formObject} ksc="d" rowKey="" className="uiActionButton"
                action={{ actionId: "edit", actionMessage: "Processing Action", paramName: "batchAction", actionName: "itemPromo", actionParam: { ops: 1, sview: "itemPromo", dIds:selectedDids.join(",") }, 
                containerKey:"popup", onModalClose:onPopupClose }}
                text={<SarasTrans value="Set Desc." />}>
            </FormButton>
            <div className="uiFlexBox">
                <span><SarasTrans value="Set Tag" /></span>
                <FormInput formObject={formObject} rowKey="" className="uiInput"
                    action={{ InputType: "ac", paramName: "tag", acMethod: "Tag" }}
                />
                <FormSH formObject={formObject} rowKey="" style={{color:'white'}}
                    action={{
                        actionId: "new", paramName: "tag",actionMessage: "Processing Action", actionName: "catDetail",
                        acDepCtrl: { 'dtId': "%dataList.valLDT", 'catId': "%dataList.valLCat" }, containerKey: "popup"
                    }}
                     >
                </FormSH>

                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{ actionId: "save", actionMessage: "Processing Action", actionName: "itemComp", actionParam: {actionType:"setTag", ops: 1, dIds:selectedDids.join(","), "tagId":"#tag" },onSuccess:onActionSuccess  }}
                    text={<SarasTrans value="Link" />}>
                </FormButton>

                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{ actionId: "save", actionMessage: "Processing Action", actionName: "itemComp", actionParam: {actionType:"removeTag", ops: 1, dIds:selectedDids.join(","), "tagId":"#tag" },onSuccess:onActionSuccess }}
                    text={<SarasTrans value="Unlink" />}>
                </FormButton>
            </div>
            <div className="uiFlexBox">
                <span><SarasTrans value="Set" /></span>
                <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }} placeholder="Min. Qty"
                    action={{ InputType: "input", paramName: "minQty"}}
                />
                <span className='uiSpacerH5'><SarasTrans value="Set Price" /></span>
                
                <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }}
                    placeholder="Value" action={{ InputType: "input", paramName: "itemPrice" }}
                />
                <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }}
                    placeholder="Currency" action={{ InputType: "ac", paramName: "priceCurrency", acMethod:"CurrencyName" }}
                />
                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{ actionId: "save", actionMessage: "Processing Action", actionName: "itemComp", actionParam: {actionType:"updatePrice", ops: 1, dIds:selectedDids.join(",") },onSuccess:onActionSuccess }}
                    text={<SarasTrans value="Update" />}>
                </FormButton>
            </div>
        </div>
    )
}

export default withView(DesignOPSSearchBatchAction, "", "");